export default __webpack_public_path__ + "static/media/Calendar.8dd3a533.svg";